module.exports = __webpack_public_path__ + "static/media/champion.c2609d18.svg";